import { render, staticRenderFns } from "./Busqueda.vue?vue&type=template&id=622afb9b&"
import script from "./Busqueda.vue?vue&type=script&lang=js&"
export * from "./Busqueda.vue?vue&type=script&lang=js&"
import style0 from "./Busqueda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('622afb9b')) {
      api.createRecord('622afb9b', component.options)
    } else {
      api.reload('622afb9b', component.options)
    }
    module.hot.accept("./Busqueda.vue?vue&type=template&id=622afb9b&", function () {
      api.rerender('622afb9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Dashboard/Busqueda.vue"
export default component.exports